
import { Component, Vue } from "vue-property-decorator";
import { PFormInputText, PDropDownContainer, PButton, SelectType, PFormSelect } from "@/common/components";
import { PRow } from "@/common/components/look/PRow";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import { EventBus } from "@/event-bus";

@Component({
  name: "support-drop-down-actual-id",
  components: {
    PRow,
    PButton,
    PFormInputText,
    PDropDownContainer,
    PFormSelect,
    PIcon,
  },
})
export class SupportDropDownActualId extends Vue {
  filterProperties: SelectType[] = [];
  selectItemFilterPropertie = "";
  link = "link";

  async created(): Promise<void> {
    const result1: string[] = await this.$services.supportTransaction.fetchActualIds();
    result1.forEach((it: string) => this.filterProperties.push({ text: it.toString(), value: it.toString() }));
  }

  setItem(item: string): void {
    this.selectItemFilterPropertie = item;
  }

  reset(): void {
    this.selectItemFilterPropertie = this.$t("support_panel.dropdown.placeholder_actual_id").toString();
    EventBus.$emit("clear-filter-by-actual-id", this.selectItemFilterPropertie);
    alert("Filtro reseteado");
  }

  filter(): void {
    EventBus.$emit("filter-by-actual-id-support", { actualId: this.selectItemFilterPropertie });
    alert("Filtro aplicado");
  }
}
export default SupportDropDownActualId;
